import { Fragment } from 'react'
import { SectionLabel } from '@/components/custom/section-label'
import { cn } from '@/lib/utils'

export interface AlignedSortFilterGroupItem {
  key?: string
  label?: string
  children: React.ReactNode
}

export function AlignedSortFilterGroups(props: {
  groups: AlignedSortFilterGroupItem[]
  direction?: 'horizontal' | 'vertical'
}) {
  const isHorizontal = props.direction === 'horizontal'

  return (
    <div className={cn('grid items-center gap-2', isHorizontal ? 'flex' : 'grid-cols-[auto_1fr]')}>
      {props.groups.map((group) => (
        <Fragment key={group.key ?? group.label ?? 'unlabeled'}>
          {group.label ? (
            <>
              <SectionLabel className="h-full items-baseline justify-end">{group.label}</SectionLabel>
              <div className="flex items-center gap-2">{group.children}</div>
            </>
          ) : (
            <>
              <div />
              <div className="flex items-center gap-2">{group.children}</div>
            </>
          )}
        </Fragment>
      ))}
    </div>
  )
}
